/**
 * ลิงก์ใบเบิก-ยืมอุปกรณ์ — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลรายละเอียด/ฟอร์ม)
 *   /stock/issues                    ศูนย์ใบเบิก (stock_issues.view)
 *   /stock/issues/:id                รายละเอียด (stock_issues.view)
 *   /stock/issues/new[?rental_id=][&maintenance_id=]   สร้างใบเบิก (stock_issues.create) · rental_id = ผูกสัญญาเช่า (อ้างอิงเฉย ๆ)
 *     · maintenance_id = เปิดจากหน้าเคสซ่อม (FB-2026-0008) → เติมเหตุผล "จากเคสซ่อม #N" (stock_issues ไม่มีคอลัมน์อ้างอิงเคส)
 * ลิงก์เก่า `/stock/pending-returns?issue=<id>` (แจ้งเตือนเลยกำหนดคืน) → หน้ารายละเอียด
 */
export const STOCK_ISSUES_PATH = '/stock/issues';

/** หน้ารายละเอียดใบเบิก — id ไม่ถูกต้อง = ศูนย์ใบเบิก */
export function stockIssueDetailUrl(issueId: number | string | null | undefined): string {
  const n = Number(issueId);
  return Number.isInteger(n) && n > 0 ? `${STOCK_ISSUES_PATH}/${n}` : STOCK_ISSUES_PATH;
}

const positiveInt = (v: unknown): number | null => {
  const n = Number(v);
  return v !== null && v !== undefined && v !== '' && Number.isInteger(n) && n > 0 ? n : null;
};

/** หน้าสร้างใบเบิก · ส่ง rentalId = ผูกสัญญาเช่า (ช่องอ้างอิง ไม่กระทบสัญญา) · maintenanceId = เปิดจากเคสซ่อม */
export function stockIssueNewUrl(rentalId?: number | null, maintenanceId?: number | null): string {
  const params = new URLSearchParams();
  const r = positiveInt(rentalId);
  const m = positiveInt(maintenanceId);
  if (r) params.set('rental_id', String(r));
  if (m) params.set('maintenance_id', String(m));
  const qs = params.toString();
  return qs ? `${STOCK_ISSUES_PATH}/new?${qs}` : `${STOCK_ISSUES_PATH}/new`;
}

/** เหตุผลตั้งต้นของใบเบิกที่เปิดจากเคสซ่อม (FB-2026-0008) — ผู้ใช้แก้/เติมต่อได้ */
export function maintenanceStockIssueReason(maintenanceId: number): string {
  return `จากเคสซ่อม #${maintenanceId} — ขอเบิก/เปลี่ยนอุปกรณ์เสริม: `;
}
